var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-kinostart"},[_c('div',{staticClass:"text",class:_vm.$mq,domProps:{"innerHTML":_vm._s(_vm.$t('kinostart.' + _vm.kinostart))}})])}
var staticRenderFns = []

export { render, staticRenderFns }